export default __webpack_public_path__ + "static/banner-two-64e070855dd62ef085e4c3b20af59cdc.jpg";